import { render, staticRenderFns } from "./UserPublication.vue?vue&type=template&id=40cb877a&scoped=true"
import script from "./UserPublication.vue?vue&type=script&lang=js"
export * from "./UserPublication.vue?vue&type=script&lang=js"
import style0 from "./UserPublication.vue?vue&type=style&index=0&id=40cb877a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb877a",
  null
  
)

export default component.exports